import React, { useState } from "react";
import MaintenanceSalaryCombinationCodeTable from "./components/MaintenanceSalaryCombinationCodeTable";
import MaintenanceSalaryCombinationCodeAddEditModal from "./components/MaintenanceSalaryCombinationCodeAddEditModal";
import { SearchBar, Button } from "../../../../common/APICommon";
import AddIcon from '@mui/icons-material/Add';

const MaintenanceSalaryCombinationCodeModule = ({
  user,
  data,
  loading,
  searchData,
  getCodeById,
  createCode,
  updateCode
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const handleEdit = async (item) => {
    const res = await getCodeById(item.id);
    if (res.success) {
      setSelectedItem(res.data);
      setIsModalOpen(true);
    }
  };

  const handleSave = async (form) => {
    if (selectedItem) {
      const audit = [{
        setupArea: "Maintenance Salary Combination Code",
        actionTaken: "update",
        field: "Details",
        newValue: `Code: ${form.code}, Amount: ${form.amount}`,
        oldValue: `Code: ${selectedItem.code}, Amount: ${selectedItem.amount}`,
        dateSaved: new Date(),
        savedById: user.id
      }];
      const res = await updateCode(selectedItem.id, form, audit);
      if (res.success) setIsModalOpen(false);
    } else {
      const audit = {
        setupArea: "Maintenance Salary Combination Code",
        actionTaken: "insert",
        field: "Add",
        newValue: `New code: ${form.code}`,
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id
      };
      const res = await createCode(form, audit);
      if (res.success) setIsModalOpen(false);
    }
  };

  return (
    <>
      <div className='p-4 space-y-4'>
        <div className="flex justify-between items-center">
          <SearchBar handleFilter={searchData} />
          <Button
            icon={<AddIcon />}
            name={"Add Combination Code"}
            className={"bg-customGreen hover:bg-customGreenHover border-none"}
            onClick={() => { setSelectedItem(null); setIsModalOpen(true); }}
          />
        </div>
        <MaintenanceSalaryCombinationCodeTable
          data={data}
          onEdit={handleEdit}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </div>
      <MaintenanceSalaryCombinationCodeAddEditModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        selectedItem={selectedItem}
        onSave={handleSave}
      />
    </>
  );
};

export default MaintenanceSalaryCombinationCodeModule;